import { render, staticRenderFns } from "./bizcompTitle.vue?vue&type=template&id=08a75c91"
import script from "./bizcompTitle.vue?vue&type=script&lang=js"
export * from "./bizcompTitle.vue?vue&type=script&lang=js"
import style0 from "./bizcompTitle.vue?vue&type=style&index=0&id=08a75c91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports